import { setLocalStorageItem, getLocalStorageItem, Key } from 'src/utils/localStorage';

export const getShowSavePostModalPreference = () => {
  return JSON.parse(getLocalStorageItem(Key.showSavedPostModalPreference) || `{"${Key.showSavedPostModalPreference}": true}`);
};

export const setShowSavePostModalPreference = (preference: boolean) => {
  setLocalStorageItem(Key.showSavedPostModalPreference, JSON.stringify(preference));
};
